// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Credit Card';

export function CreditCard() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-label={TITLE}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 6C3.67157 6 3 6.67157 3 7.5V16.5C3 17.3284 3.67157 18 4.5 18H19.5C20.3284 18 21 17.3284 21 16.5V7.5C21 6.67157 20.3284 6 19.5 6H4.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H19.5C19.7761 7 20 7.22386 20 7.5V8H4V7.5ZM4 11V16.5C4 16.7761 4.22386 17 4.5 17H19.5C19.7761 17 20 16.7761 20 16.5V11H4Z"
        fill="currentColor"
      />
    </svg>
  );
}
